import { BackupCodesNotice } from './BackupCodesNotice';
import type { TwoFactorEnrollResult } from '../hooks/useTwoFactorMutations';

interface TwoFactorEnrollStepProps {
  data: TwoFactorEnrollResult;
}

/**
 * 2FA enrollment 안내. QR 라이브러리를 도입하지 않고 otpauth URI 와 secret 을 텍스트로
 * 노출해 인증 앱에 수동 등록하도록 안내한다. backupCodes 는 1회 노출.
 */
export const TwoFactorEnrollStep = ({ data }: TwoFactorEnrollStepProps) => (
  <div className="flex flex-col gap-4" data-testid="two-factor-enroll-step">
    <p className="text-sm" style={{ color: 'var(--content-default)' }}>
      인증 앱(Google Authenticator, Authy 등)에 아래 키를 등록한 뒤, 앱에 표시되는 6자리 코드를
      입력하세요.
    </p>

    <div className="flex flex-col gap-1.5">
      <span className="text-xs font-medium" style={{ color: 'var(--content-muted)' }}>
        otpauth URI
      </span>
      <code
        className="block break-all rounded-md px-3 py-2 text-xs"
        style={{
          background: 'var(--surface-0)',
          border: '1px solid var(--divider-strong)',
          color: 'var(--content-strong)',
        }}
        data-testid="two-factor-otpauth-uri"
      >
        {data.otpAuthUri}
      </code>
    </div>

    <div className="flex flex-col gap-1.5">
      <span className="text-xs font-medium" style={{ color: 'var(--content-muted)' }}>
        수동 입력 키 (secret)
      </span>
      <code
        className="block break-all rounded-md px-3 py-2 text-sm font-mono tracking-widest"
        style={{
          background: 'var(--surface-0)',
          border: '1px solid var(--divider-strong)',
          color: 'var(--content-strong)',
        }}
        data-testid="two-factor-secret"
      >
        {data.secret}
      </code>
    </div>

    <BackupCodesNotice codes={data.backupCodes} />
  </div>
);
